"use strict";

Core.SubContractor = Core.ShareableModel.extend({
    urlRoot: Core.contextRoot + '/subcontractor',
    editGroupPermission: 'admin_subcontractors',

    defaults: function() { return {
        subContractorType: 'BUSINESS',
        selfInvoiced: false,
    }; },
});

Core.SubContractors = Backbone.Collection.extend({
    model: Core.SubContractor,
    canPaginate: true,

    url: function() {
        var path = '';
        var params = {};
        if (this.filterParams && this.filterParams.path) path = this.filterParams.path;
        if (this.filterParams && this.filterParams.includeInactive) params.inactive = '';
        if (this.filterParams && this.filterParams.groups) params.groups = this.filterParams.groups;
        if (this.searchQuery) {
            params.q = this.searchQuery;
            params.limit = this.searchLimit || Core.SEARCH_RESULTS_LIMIT;
            path = 'search';
        }
        return Core.contextRoot + '/subcontractor' + (path ? '/' + path : '') + (Object.keys(params).length > 0 ? '?' + $.param(params) : '');
    },

    initialize: function(models, options) {
        this.filterParams = (options && options.filterParams) || {};
    },
});
